module.exports = __webpack_public_path__ + "static/img/end.30121af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Magazine/end.jpg
// module id = 0zyp
// module chunks = 1